import React from 'react';
import useBrowserMode from '../../../hooks/useBrowserMode';
import useLocaleMode from '../../../hooks/useLocaleMode';
import useSessionState from '../../../hooks/useSessionState';
import './tabProducts.scss';

const TabProducts = props => {

  const newSlug = props.slug.substring(props.slug.lastIndexOf('/') + 1);
  const { locale } = useLocaleMode();
  const nodeContainer = React.useRef();
  const { isBrowser } = useBrowserMode();
  // const isBenefits = isBrowser && (props.slug === "programa-de-beneficios" ? false : window.location.pathname.includes("beneficios"));
  const { isLoggedUser } = useSessionState();

  React.useEffect(() => {
    // if (props.slug === "productos" || props.slug === "muestra-gratis" || props.slug === "pide-tu-muestra" || props.slug === "programa") {
    //   nodeContainer.current.scrollLeft = 0;
    // } else {
    const itemSelect = (window.location.pathname);

    let index = props.tabs.opcionesMenu.findIndex(x => {
      if (x.slug.charAt(0) !== "/") {
        x.slug = "/" + x.slug
      }
      return x.slug === itemSelect
    });
    if (props.slug === "acumula-puntos") {
      index = 1
    }
    let scrollY = 0;
    for (let i = 0; i < index; i++) {
      scrollY += nodeContainer.current.children[i].clientWidth
    }
    nodeContainer.current.scrollLeft = scrollY;
    // }
  });

  return (
    <>
      {isBrowser && (locale &&
        <aside className={`f-tabs-products f-${(locale === "es-CO" || locale === "es-EC" || locale === "es-PE") ? newSlug : (locale !== "es-CO" && !props.slug.includes("productos")) ? newSlug : "productos"}`}>
          <div ref={nodeContainer} className={`f-tabs-container ` /*+ (isBenefits ? 'f-tabs-container--center' : '')*/}>
            {isBrowser && props.tabs.opcionesMenu.map((tab, index) => {
              const { nombre, slug } = tab;
              let newSlugTab = slug.substring(slug.lastIndexOf('/') + 1);
              let newSlugHash = newSlugTab.split('#');
              let realSlug = newSlugHash[1] ? newSlugHash[1] : newSlugHash[0];
              return (
                <React.Fragment key={index}>
                  {!isLoggedUser && window.location.pathname.includes("/beneficios") && slug.includes("/redime-puntos") ? <></> :
                    <a href={slug}
                      className={
                        `f-tab f-tab-${realSlug}` +
                        ((locale === "es-AR" || locale === "es-BO") && props.slug.includes("productos") ? ' f-tab-active-productos' :
                          (window.location.hash !== '' ?
                            (window.location.hash.substr(1) === realSlug ?
                              ` f-tab-active-${realSlug}` : '') :
                            (newSlug === realSlug ? ` f-tab-active-${newSlug}` :
                              props.slug.includes("redime-puntos") && realSlug === 'bonos-para-comprar-tena' ?
                                ` f-tab-active-bonos-para-comprar-tena` : '')))}>
                      {nombre}
                    </a>
                  }
                </React.Fragment>
              )
            })}
          </div>
        </aside>
      )}
    </>
  )
};

export default TabProducts;